import { Title } from "@solidjs/meta";
import { For } from "solid-js";
import { BreadCrumbs } from "../breadcrumbs/breadcrumbs";
import { Container } from "../layout/container/container";
import { Header } from "../layout/header/header";
import { Link } from "../link/link";
import { ApiResponse, CropTypeCategoriesProps } from "../start/start-types";

export const Categories = (props: CropTypeCategoriesProps) => {
    const categories = (): ApiResponse => props.cropTypeCategoriesData()?.cropTypeCategories;
    const prompt = 'Välj kategori'

    return (
        <div>
            <Title>Strategikategorier</Title>
            <BreadCrumbs prompt={`${prompt}...`} />
            <Header header='Rekommendationer' />
            <Container header={prompt}>
                <For each={categories()?.rows}>
                    {(term) => (
                        <Link href={`/strategier/${term.slug}`}>{term.name}</Link>
                    )}
                </For>
            </Container>
        </div>
    );
};
